export const SET_PAYER_DATA = "SET_PAYER_DATA";
export const SET_PAYER_VALIDATION_FIELDS = "SET_PAYER_VALIDATION_FIELDS";
export const SET_DOWNGRADE_DATA = "SET_DOWNGRADE_DATA";
